export default __webpack_public_path__ + "static/media/Google Chrome.cb9e2605.svg";